import {mapGetters, mapMutations, mapActions} from 'vuex';
import * as moment from "moment/moment";

export default {
    props: ['popupType', 'selectedItem'],
    data() {
        return {
            form: {
                title: '',
                description: '',
                can_edit_orders: false,
                can_add_new_orders: false,
                can_send_sms: false,
                can_show_orders_without_department: false,
                hide_phones_in_orders: false,
                only_his_orders_and_new: false,
                accept_to_menu_items: [
                    {
                        item_name: this.$t('menu.contacts'),
                        id: 0,
                        value: false,
                        type: 0
                    },
                    {
                        item_name: this.$t('menu.users_group'),
                        id: 1,
                        value: false,
                        type: 1
                    },
                    {
                        item_name: this.$t('menu.users'),
                        id: 2,
                        value: false,
                        type: 1
                    },
                    {
                        item_name: this.$t('menu.department'),
                        id: 3,
                        value: false,
                        type: 1
                    },
                    {
                        item_name: this.$t('menu.customer-groups'),
                        id: 4,
                        value: false,
                        type: 1
                    },
                    {
                        item_name: this.$t('menu.customers'),
                        id: 5,
                        value: false,
                        type: 1
                    },
                    {
                        item_name: this.$t('menu.orders'),
                        id: 6,
                        value: false,
                        type: 0
                    },
                    {
                        item_name: this.$t('menu.status-orders'),
                        id: 7,
                        value: false,
                        type: 1
                    },
                    {
                        item_name: this.$t('menu.type-orders'),
                        id: 8,
                        value: false,
                        type: 1
                    },
                    {
                        item_name: this.$t('menu.orders-drag-list'),
                        id: 9,
                        value: false,
                        type: 1
                    },
                    {
                        item_name: this.$t('menu.orders-drag-list-new'),
                        id: 10,
                        value: false,
                        type: 1
                    },
                    {
                        item_name: this.$t('menu.type-delivery'),
                        id: 11,
                        value: false,
                        type: 1
                    },
                    {
                        item_name: this.$t('menu.catalog'),
                        id: 12,
                        value: false,
                        type: 0
                    },
                    {
                        item_name: this.$t('menu.product-category'),
                        id: 13,
                        value: false,
                        type: 1
                    },
                    {
                        item_name: this.$t('menu.products'),
                        id: 14,
                        value: false,
                        type: 1
                    },
                    {
                        item_name: this.$t('menu.manufacturer'),
                        id: 15,
                        value: false,
                        type: 1
                    },
                    {
                        item_name: this.$t('menu.sites'),
                        id: 16,
                        value: false,
                        type: 1
                    },
                    {
                        item_name: this.$t('menu.material'),
                        id: 17,
                        value: false,
                        type: 1
                    },
                    {
                        item_name: this.$t('menu.model'),
                        id: 18,
                        value: false,
                        type: 1
                    },


                    // {
                    //     item_name: 'Отправка товара',
                    //     id: 19,
                    //     value: false,
                    //     type: 0
                    // },

                    // {
                    //     item_name: 'Список для куръера',
                    //     id: 20,
                    //     value: false,
                    //     type: 1
                    // },
                    //
                    // {
                    //     item_name: 'Реестры НП',
                    //     id: 21,
                    //     value: false,
                    //     type: 1
                    // },


                    {
                        item_name: this.$t('menu.warehouse'),
                        id: 22,
                        value: false,
                        type: 0
                    },
                    {
                        item_name: this.$t('menu.warehouses'),
                        id: 23,
                        value: false,
                        type: 1
                    },

                    {
                        item_name: this.$t('menu.warehouse-products'),
                        id: 24,
                        value: false,
                        type: 1
                    },
                    {
                        item_name: this.$t('menu.provisioners'),
                        id: 25,
                        value: false,
                        type: 1
                    },
                    // {
                    //     item_name: 'Приход товара',
                    //     id: 26,
                    //     value: false,
                    //     type: 1
                    // },
                    // {
                    //     item_name: 'Перемищение товара',
                    //     id: 27,
                    //     value: false,
                    //     type: 1
                    // },
                    {
                        item_name: this.$t('menu.templates'),
                        id: 28,
                        value: false,
                        type: 0
                    },
                    {
                        item_name: this.$t('menu.sms-templates'),
                        id: 29,
                        value: false,
                        type: 1
                    },
                    {
                        item_name: this.$t('menu.modules'),
                        id: 30,
                        value: false,
                        type: 0
                    },
                    {
                        id: 31,
                        item_name: this.$t('menu.plugins'),
                        value: false,
                        type: 1
                    },
                    {
                        id: 32,
                        item_name: this.$t('menu.statistic'),
                        value: false,
                        type: 0
                    },
                    {
                        id: 33,
                        item_name: this.$t('menu.stats_orders'),
                        value: false,
                        type: 1
                    },
                    {
                        id: 34,
                        item_name: this.$t('menu.lack-of'),
                        value: false,
                        type: 1
                    },
                    {
                        id: 35,
                        item_name: this.$t('menu.finances'),
                        value: false,
                        type: 0
                    },
                    {
                        id: 36,
                        item_name: this.$t('menu.rate'),
                        value: false,
                        type: 1
                    },
                    {
                        id: 37,
                        item_name: this.$t('menu.card-list'),
                        value: false,
                        type: 1
                    },
                    {
                        id: 38,
                        item_name: this.$t('menu.statements'),
                        value: false,
                        type: 1
                    },
                    {
                        id: 39,
                        item_name: this.$t('menu.archives'),
                        value: false,
                        type: 0
                    },
                    {
                        id: 40,
                        item_name: this.$t('menu.sms-list'),
                        value: false,
                        type: 1
                    },
                    {
                        id: 41,
                        item_name: this.$t('menu.call-list'),
                        value: false,
                        type: 1
                    },
                ],
                accept_to_statuses: []
            },
            checkedAllMenu: false,
            checkedAllStatuses: false,
        }
    },
    computed: {
        ...mapGetters({
            userGroup: 'contacts/userGroup',
            orderStatusList: 'orders/orderStatusList',
        }),
    },
    watch: {
        userGroup(e) {
            if (e) {
                let menuList = [];
                e.accept_to_menu_items.map((itemMenu, index) => {
                    menuList.push({
                        item_name: itemMenu.item_name,
                        id: itemMenu.id ? itemMenu.id : index,
                        value: Boolean(itemMenu.value),
                        type: Boolean(itemMenu.type),
                    })
                });
                this.form.title = e.title;
                this.form.description = e.description;
                this.form.can_edit_orders = Boolean(e.can_edit_orders);
                this.form.can_send_sms = Boolean(e.can_send_sms);
                this.form.hide_phones_in_orders = Boolean(e.hide_phones_in_orders);
                this.form.can_show_orders_without_department = Boolean(e.can_show_orders_without_department);
                this.form.can_add_new_orders = Boolean(e.can_add_new_orders);
                this.form.only_his_orders_and_new = Boolean(e.only_his_orders_and_new);
                menuList.map(menuListItem => {
                    this.form.accept_to_menu_items.map(item => {
                        if (item.item_name === menuListItem.item_name) {
                            item.value = menuListItem.value
                        }
                    })
                })
            }
        },
        orderStatusList(e) {
            if (e && !this.userGroup) {
                e.data.map(item => {
                    this.form.accept_to_statuses.push({
                        color: item.color,
                        id: item.id,
                        title: item.title,
                        value: false,
                    })
                });
            } else if (e && this.userGroup) {
                let statusesList = [];
                e.data.map((item, index) => {
                    statusesList.push({
                        color: item.color ? item.color : '#000',
                        title: item.title ? item.title : index,
                        id: item.id ? item.id : index,
                        value: false
                    })
                })
                this.userGroup.accept_to_statuses.map(item => {
                    statusesList.map(itemMenu => {
                        if (item.id === itemMenu.id) {
                            itemMenu.value = Boolean(item.value)
                        }
                    })
                })

                this.form.accept_to_statuses = statusesList
            }
        }
    },
    created() {
        this.getOrderStatuses()
    },
    methods: {
        changeToggle() {
            const audio = new Audio(require('../../../../assets/sounds/BUTTON_SWITCH.mp3'))
            audio.play();
        },
        changeMenuValueToBoolean(item) {
            return Boolean(item)
        },
        closePopup() {
            this.$emit('closePopup')
        },
        sendChanges() {
            let menuItems = [];
            this.form.accept_to_menu_items.map(item => {
                menuItems.push({
                    item_name: item.item_name,
                    id: item.id,
                    value: Number(item.value),
                    type: Number(item.type),
                })
            })

            let statusesList = [];
            this.form.accept_to_statuses.map((itemMenu, index) => {
                statusesList.push({
                    color: itemMenu.color ? itemMenu.color : '#000',
                    title: itemMenu.title ? itemMenu.title : index,
                    id: itemMenu.id ? itemMenu.id : index,
                    value: Number(itemMenu.value)
                })
            })
            const payload = {
                id: this.userGroup ? this.userGroup.id : null,
                title: this.form.title,
                description: this.form.description,
                can_edit_orders: Number(this.form.can_edit_orders),
                can_send_sms: Number(this.form.can_send_sms),
                hide_phones_in_orders: Number(this.form.hide_phones_in_orders),
                can_show_orders_without_department: Number(this.form.can_show_orders_without_department),
                can_add_new_orders: Number(this.form.can_add_new_orders),
                only_his_orders_and_new: Number(this.form.only_his_orders_and_new),
                accept_to_menu_items: menuItems,
                accept_to_statuses: statusesList,
            };
            if (this.userGroup) {
                this.$emit('changeCustomerGroup', payload)
            } else {
                this.$emit('sendCustomerGroup', payload)
            }
        },
        createdDate(date) {
            return moment(date).format('YYYY-MM-DD HH:mm')
        },
        checkAllMenu() {
            if (this.checkedAllMenu) {
                this.form.accept_to_menu_items.map(item => {
                    item.value = true;
                })
            } else {
                this.form.accept_to_menu_items.map(item => {
                    item.value = false;
                })
            }
        },
        checkAllStatuses() {
            if (this.checkedAllStatuses) {
                this.form.accept_to_statuses.map(item => {
                    item.value = true;
                })
            } else {
                this.form.accept_to_statuses.map(item => {
                    item.value = false;
                })
            }
        },
        ...mapActions({
            getOrderStatuses: 'orders/getOrderStatuses',
        }),
        ...mapMutations({
            changeUserGroup: 'contacts/changeUserGroup',
        })
    },
    destroyed() {
        this.changeUserGroup({models: null});
    }
}
